<template>
  <div id="wrapper">
      <h2>{{selectedItem.title}}</h2>
      <div class="details" v-html="selectedItem.text"></div>
  </div>
</template>

<script>
    export default {
        name: "PressReleaseDetails",
        props: ['selectedItem'],
        data () {
            return {
            }
        }
    }
</script>

<style scoped>
  h2 {
    border-bottom: 1px solid #dbd2d2;
    padding-bottom: 20px;
    margin-bottom: 10px;
  }

  .details {
    color: #333;
  }
</style>
